import { keyframes } from 'styled-components';
import styled from 'foundations-theming-specialty/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const dashAnimation = keyframes(["0%{stroke-dasharray:1,150;stroke-dashoffset:0;}50%{stroke-dasharray:90,150;stroke-dashoffset:-50px;}100%{stroke-dasharray:90,150;stroke-dashoffset:-140px;}"]);
const StyledContainer = styled.div.withConfig({
  displayName: "LoadingSpinner__StyledContainer",
  componentId: "sc-1p5wvw2-0"
})(["display:flex;justify-content:center;align-items:center;width:40px;height:40px;"]);
function getRGB(color) {
  const RGB_REGEX = /^rgb/i;
  let r;
  let g;
  let b;
  try {
    if (RGB_REGEX.test(color)) {
      const match = color.match(/(\d+)\D+(\d+)\D+(\d+)/);
      if (!match) return {};
      [, r, g, b] = match.map(Number);
    } else {
      let hex = color.toLowerCase().replace(/^#/, '');
      if (hex.length === 3) hex = hex.replace(/([0-9a-f])/g, '$1$1');
      r = parseInt(hex.substring(0, 2), 16);
      g = parseInt(hex.substring(2, 4), 16);
      b = parseInt(hex.substring(4, 6), 16);
    }
    return [r, g, b].some(isNaN) ? {} : {
      r,
      g,
      b
    };
  } catch (_unused) {
    return {};
  }
}
const rgba = (color, opacity = 1) => {
  const {
    r,
    g,
    b
  } = getRGB(color);
  return r !== undefined ? `rgba(${r}, ${g}, ${b}, ${opacity})` : color;
};
const StyledPath = styled.circle.withConfig({
  displayName: "LoadingSpinner__StyledPath",
  componentId: "sc-1p5wvw2-1"
})(["stroke:", ";"], ({
  theme
}) => rgba(theme.color['icon-interactive-default'], 0.21));
const StyledAnimatedPath = styled.circle.withConfig({
  displayName: "LoadingSpinner__StyledAnimatedPath",
  componentId: "sc-1p5wvw2-2"
})(["stroke:", ";stroke-linecap:round;stroke-dasharray:1,150;stroke-dashoffset:0;animation:", " 2s cubic-bezier(0.42,0,0.58,1) infinite;"], ({
  theme
}) => theme.color['icon-interactive-default'], dashAnimation);
export const LoadingSpinner = () => /*#__PURE__*/_jsx(StyledContainer, {
  children: /*#__PURE__*/_jsxs("svg", {
    height: "28px",
    width: "28px",
    viewBox: "0 0 50 50",
    children: [/*#__PURE__*/_jsx(StyledPath, {
      cx: "25",
      cy: "25",
      r: "22.5",
      fill: "none",
      strokeWidth: "5"
    }), /*#__PURE__*/_jsx(StyledAnimatedPath, {
      cx: "25",
      cy: "25",
      r: "22.5",
      fill: "none",
      strokeWidth: "5"
    })]
  })
});